import './design/tokens.css';
import './design/base.css';
import './design/components.css';
import './book.css';
import { applyTheme, readStoredTheme } from './lib/theme';
import { watchWidget } from './lib/widget';

applyTheme(readStoredTheme(localStorage), document.documentElement, localStorage);

/** Update the live region: text drives the announcement, class drives visibility. */
function setStatus(text: string, state: 'waiting' | 'error' | null): void {
  const el = document.getElementById('widget-status');
  if (!el) return;
  if (state === null) {
    el.textContent = '';
    el.classList.add('is-quiet');
    return;
  }
  el.textContent = text;
  el.dataset.state = state;
  el.classList.remove('is-quiet');
}

// Surface a status if the widget iframe hasn't arrived shortly after load
// (script blocked, network failure, origin not allowed in Hospitable).
watchWidget(
  {
    isReady: () => document.getElementById('booking-iframe') !== null,
    onSlow: () => setStatus('Loading the booking calendar…', 'waiting'),
    onFailed: () =>
      setStatus(
        'The booking calendar could not load. Refresh to retry, or email hosts@unconqueredridge.com with your dates.',
        'error',
      ),
    onReady: () => {
      setStatus('', null);
      // The loader hardcodes title="Booking Widget"; name the frame properly.
      document
        .getElementById('booking-iframe')
        ?.setAttribute('title', 'Availability calendar and booking checkout');
    },
  },
  (ms, fn) => window.setTimeout(fn, ms),
);
